/* eslint-disable no-console */
import axios from 'axios';
import config from '@/vue-caas/config/config.js';

 const baseURI = config.integrationsetApiUrl;

const integrationSetStoreModule = {
 // namespaced: false,

 state: {
   integrationSetList: Array,
   integrationSetDetail: Array,
   integrationSetExcelData: Array,
   integrationSetContent: String,
   integrationSetSample: String
 },
 mutations: {
   'SET_STORE_INTEGRATION_SET_LIST' (state, integrationSetList) {
     state.integrationSetList = integrationSetList;
   },
   'SET_STORE_INTEGRATION_SET_DETAIL' (state, integrationSetDetail) {
     state.integrationSetDetail = integrationSetDetail;
   },
   'SET_STORE_INTEGRATION_SET_EXCELDATA' (state, integrationSetExcelData) {
     integrationSetExcelData === '' ? state.integrationSetExcelData = "" : state.integrationSetExcelData = integrationSetExcelData;
   },
   'SET_STORE_READFILE_SET_CONTENT' (state, integrationSetContent) {
     state.integrationSetContent = integrationSetContent;
   },
   'SET_STORE_READFILE_SET_SAMPLE' (state, integrationSetSample) {
     integrationSetSample === '' ? state.integrationSetSample = "" : state.integrationSetSample = integrationSetSample;
  },
 },
 actions: {
   getIntegrationSetList: async ({commit}) => {
       await axios.post(baseURI + "/integrationset/list").then((response) => {
          commit('SET_STORE_INTEGRATION_SET_LIST', response.data);

        }).catch((ex) => {
          console.log("EX : "+ex);
        });
   },

   getIntegrationSetDetail: async ({commit}, param) => {
     // 2021.12.6 203728 change condition in Integration Set
      await axios.post(baseURI + `/integrationset/detail/${param.tmpId}&${param.message_id}&${param.version}`).then((response) => {
        commit('SET_STORE_INTEGRATION_SET_DETAIL', response.data);

      }).catch((ex) => {
        console.log(ex);
      });
   },

   getIntegrationSetExcelData: async ({commit}, param) => {
    //  await axios.post(baseURI + "/integrationset/exceldata/"+param).then((response) => {
    //    commit('SET_STORE_INTEGRATION_SET_EXCELDATA', response.data);

    //     console.log("response.data : " +JSON.stringify(response.data));

    //  }).catch((ex) => {
    //    console.log(ex);
    //  });
    await axios({
      url: baseURI + "/integrationset/exceldata/"+param,
      method: 'POST',
      responseType: 'blob'
    }).then((response) => {
     // commit('SET_STORE_INTEGRATION_SET_EXCELDATA', response);
      let blob = new Blob([response.data], { type: response.headers['content-type'] })
      commit('SET_STORE_INTEGRATION_SET_EXCELDATA', blob);
    })
    .catch((ex) => {
      console.log(ex);
    });
  },


   getReadFileContent: async ({commit}, param) => {
     await axios.post(baseURI + `/integrationset/sample/${param.tmpId}&${param.message_id}&${param.version}`).then((response) => {
      //console.log("response.data : " + response.data);
       commit('SET_STORE_READFILE_SET_CONTENT', response.data);
     }).catch((ex) => {
       console.log(ex);
     });
   },

   getSampleFile: async ({commit}, param) => {
    await axios.post(baseURI + `/integrationset/sampleDown/${param.tmpId}&${param.message_id}&${param.version}`).then((response) => {
    commit('SET_STORE_READFILE_SET_SAMPLE', response.data);
    }).catch((ex) => {
      commit('SET_STORE_READFILE_SET_SAMPLE', 'Data does not exist');
      console.log(ex);
    });
  },


 },
 getters: {
   integrationSetList: state => state.integrationSetList,
   integrationSetDetail: state => state.integrationSetDetail,
   integrationSetExcelData: state => state.integrationSetExcelData,
   integrationSetContent: state => state.integrationSetContent,
   integrationSetSample: state => state.integrationSetSample,
 },
};

export default integrationSetStoreModule;